import { FC } from 'react'

import { IconPlay } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const StartNodeIcon: FC<IconProps> = ({ boxSize, theme = 'green' }) => {
  return (
    <NodeIconTemplate icon={<IconPlay />} theme={theme} boxSize={boxSize} />
  )
}
